import React, { useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import MetaTags from 'react-meta-tags';
import "../styles/allexamspage.css";

// Hardcoded major categories and exams
const MAJOR_SECTIONS = [
  {
    title: "IT Certifications",
    items: [
      { id: 1, name: "AWS Certified Data Engineer Associate(DEA-C01)", slug: "aws-certified-data-engineer-associate-dea-c01", level: "Intermediate", status: "live", totalQuizzes: 12, totalQuestions: 1544, icon: "☁️", tags: ["AWS", "Data Engineer"] },
      { id: 1, name: "CompTIA Linux+ (XK0-006)", slug: "comptia-linux+-xk0-006", level: "Advanced", status: "live", totalQuizzes: 21, totalQuestions: 1702, icon: "☁️", tags: ["CompTIA", "Linux+"] },
      { id: 2, name: "CompTIA Security+ (SY0-701)", slug: "comptia-security+-sy0-701", level: "Beginner", status: "live", totalQuizzes: 17, totalQuestions: 2722, icon: "🔷", tags: ["CompTIA","Security+"] },
      { id: 3, name: "CompTIA Project+", slug: "CompTIA-Project+-exam", level: "Advanced", status: "live", totalQuizzes: 10, totalQuestions: 100, icon: "🛡️", tags: ["Project+"] },
      { id: 4, name: "CompTIA PenTest+", slug: "CompTIA-PenTest+", level: "Intermediate", status: "coming_soon", totalQuizzes: 0, totalQuestions: 0, icon: "🌥️" },
    ],
  },
  {
    title: "Medical & Healthcare",
    items: [
      { id: 5, name: "Adult CCRN", slug: "Adult CCRN", level: "Advanced", status: "live", totalQuizzes: 12, totalQuestions: 1881, icon: "🩺", tags: ["Nursing","CCRN"] },
      { id: 6, name: "USMLE Step 1 Anatomy", slug: "usmle-step-1-anatomy", level: "Advanced", status: "live", totalQuizzes: 20, totalQuestions: 1308, icon: "🧬", tags: ["USMLE","Anatomy"] },
      { id: 22, name: "NREMT Emergency Medical Technician", slug: "nremt-emergency-medical-technician", level: "Advanced", status: "live", totalQuizzes: 36, totalQuestions: 2529, icon: "🧬", tags: ["NREMT","EMT"] },
      { id: 23, name: "Medical Assistant Exam", slug: "medical-assistant-exam", level: "Advanced", status: "live", totalQuizzes: 14, totalQuestions: 1000, icon: "🧬", tags: ["Medical Assistant"] },
      { id: 23, name: "PTCB Exam", slug: "ptcb-exam", level: "Advanced", status: "live", totalQuizzes: 5, totalQuestions: 885, icon: "🧬", tags: ["Medical Assistant"] },
      
    ],
  },
  // {
  //   title: "Business & Finance",
  //   items: [
  //     { id: 7, name: "PMP Certification", slug: "PMP-Certification", level: "Advanced", status: "live", totalQuizzes: 20, totalQuestions: 200, icon: "📈", tags: ["Project", "PMI"] },
  //     { id: 8, name: "CAPM", slug: "CAPM", level: "Intermediate", status: "live", totalQuizzes: 10, totalQuestions: 100, icon: "📊" },
  //     { id: 9, name: "Financial Accounting", slug: "Financial-Accounting", level: "Beginner", status: "coming_soon", totalQuizzes: 0, totalQuestions: 0, icon: "💹" },
  //   ],
  // },
  {
    title: "Education and Teaching",
    items: [
      { id: 20, name: "FTCE Art K-12", slug: "FTCE Art K 12", level: "Advanced", status: "live", totalQuizzes: 7, totalQuestions: 1245, icon: "📈", tags: ["FTCE", "ART"] },
       { id: 21, name: "FTCE Physical Education K-12", slug: "FTCE Physical Education K-12", level: "Advanced", status: "live", totalQuizzes: 13, totalQuestions: 2029, icon: "📈", tags: ["FTCE", "PHYSICAL EDUCATION"] },
          ],
  },
  {
    title: "Legal Exams",
    items: [
      { id: 10, name: "U.S. Constitution", slug: "U.S.-Constitution", level: "Intermediate", status: "live", totalQuizzes: 25, totalQuestions: 1874, icon: "⚖️" },
      { id: 10, name: "BAR Exam Prep", slug: "BAR-Exam-Prep", level: "Advanced", status: "coming_soon", totalQuizzes: 0, totalQuestions: 0, icon: "⚖️" },
     // { id: 11, name: "CLAT", slug: "CLAT", level: "Intermediate", status: "live", totalQuizzes: 14, totalQuestions: 140, icon: "📜" },
    ],
  },
 /*  {
    title: "Engineering",
    items: [
      { id: 12, name: "Civil Engineering", slug: "Civil-Engineering", level: "Advanced", status: "live", totalQuizzes: 22, totalQuestions: 220, icon: "🏗️" },
      { id: 13, name: "Mechanical Engineering", slug: "Mechanical-Engineering", level: "Advanced", status: "coming_soon", totalQuizzes: 0, totalQuestions: 0, icon: "⚙️" },
    ],
  }, */
  {
    title: "Languages & Proficiency",
    items: [
      { id: 14, name: "American Idioms", slug: "american-idioms", level: "Intermediate", status: "live", totalQuizzes: 1, totalQuestions: 800, icon: "🗣️" },
      { id: 15, name: "IELTS Academic", slug: "IELTS-Academic", level: "Intermediate", status: "coming_soon", totalQuizzes: 0, totalQuestions: 0, icon: "📝" },
    ],
  },
  {
    title: "Professional",
    items: [
      { id: 16, name: "NASM Certified Personal Trainer", slug: "NASM-certified-personal-trainer", level: "Advanced", status: "live", totalQuizzes: 6, totalQuestions: 1973, icon: "🏋️‍♂️" },
     // { id: 17, name: "SSC CGL", slug: "SSC-CGL", level: "Intermediate", status: "coming_soon", totalQuizzes: 0, totalQuestions: 0, icon: "🧾" },
    ],
  },
  {
    title: "Academics & Entrance",
    items: [
      { id: 18, name: "AP Psychology", slug: "ap-psychology", level: "Intermediate", status: "live", totalQuizzes: 15, totalQuestions: 1201, icon: "🧠" },
      { id: 19, name: "AP Biology", slug: "ap-biology", level: "Intermediate", status: "coming_soon", totalQuizzes: 26, totalQuestions: 1260, icon: "🔤" },
    ],
  },
];

const slugify = (str) =>
  str.trim().toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');



export default function AllExamsPage() {
  const navigate = useNavigate();
  const location = useLocation();

  // login gate (unchanged)
  const itemStr = localStorage.getItem("isLogin");
  let user = null;
  try { user = itemStr ? JSON.parse(itemStr) : null; } catch (_) {}

  const handleStart = (slug, status) => {
    if (status !== "live") return;
    const now = Date.now();
    const isLoggedIn = user && user.expiry && user.expiry > now;
    /* if (!isLoggedIn) {
      alert("Please log in or sign up to start practicing.");
      return navigate("/login");
    } */
    const catName = slug.replace(/\s+/g, '-').toLowerCase();
      navigate(`/practice-test-exam-prep/${catName.replaceAll(" ","-")}`, { state: { type: "category-test" } });
  };

  // Smooth-scroll to a category if there's a hash
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      // adjust for sticky navbar if needed (offset ~80px)
      const y = el.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }, [location.hash]);

 useEffect(() => {
  if (!location.hash) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    });
  }
}, [location.hash]);

  return (
    <>

    <MetaTags>
                <title>PolyQuizz - All Practice Tests.</title>
                <meta id="meta-description" name="description" 
                content="Practice online mock tests and Tests for different certification exams." />
        
    </MetaTags>
     
      <main className="ae2-root">
       <header className="ae2-hero ae2-hero-rich">
  <div className="ae2-hero-inner-rich">
    <div className="ae2-hero-content-rich">
      <h1 className="ae2-title-rich">
  <span className="highlight-text">Ready to Start Practicing?</span> Select your exam to begin
</h1>

      <div className="ae2-lead">
        <p>
          At Poly Quizz we are committed to offering the best exam preparation platform
          for different certifications. Our practice tests use clear
          selected-response questions and detailed answer explanations. We regularly update
          content to match current exam standards so you can pass on your first try.
        </p>
      </div>

      <ul className="ae2-benefits">
        <li>
          <span className="ae2-emoji">📚</span>
          <strong>Always Up-to-Date</strong>
          <span className="ae2-desc"> — Content refreshed to match current objectives.</span>
        </li>
        <li>
          <span className="ae2-emoji">💸</span>
          <strong>Unbeatable Value</strong>
          <span className="ae2-desc"> — Affordable plans per category (monthly / 3-month / 6-month).</span>
        </li>
        <li>
          <span className="ae2-emoji">🔓</span>
          <strong>Unlimited Access</strong>
          <span className="ae2-desc"> — Full topic coverage with detailed explanations.</span>
        </li>
        <li>
          <span className="ae2-emoji">✨</span>
          <strong>Fresh Content</strong>
          <span className="ae2-desc"> — New questions are added regularly.</span>
        </li>
        <li>
          <span className="ae2-emoji">🎯</span>
          <strong>Your Success Is Our Goal</strong>
          <span className="ae2-desc"> — Our practice questions closely mirror real exam formats and difficulty levels.</span>
        </li>
         <li>
          <span className="ae2-emoji">🆕</span>
          <strong>Active learning through engagement</strong>
          <span className="ae2-desc"> — An enjoyable, intuitive, and effective learning experience to prepare you for exams.</span>
        </li>
      </ul>

     {/*  <div className="ae2-hero-ctas-rich">
        <Link to="/all-exam-prep-practice-test" className="primary-btn ae2-cta-btn">Browse Exams</Link>
        <Link to="/subscribe" className="ghost-btn ae2-cta-btn">See Plans & Pricing</Link>
        <a href="#contact" className="ghost-btn ae2-cta-btn">Contact Sales</a>
      </div> */}
    </div>

    <aside className="ae2-hero-stats-rich" aria-hidden>
      <div className="stat">
        {/* <div className="stat-num">50+</div> */}
        <div className="stat-label">Attempt FUll Test or practice sub topics</div>
      </div>
      <div className="stat">
       
        <div className="stat-label">Unlimited number of attempts</div>
      </div>
      <div className="stat">
    <div className="stat-label">Choose topic-wise practice to strengthen weak areas</div>
  </div>
      <div className="stat">
        {/* <div className="stat-num">95%</div> */}
        <div className="stat-label">Detailed explanations</div>
      </div>
      <div className="stat">
        {/* <div className="stat-num">150K+</div> */}
        <div className="stat-label">Realistic Simulations</div>
      </div>
    </aside>
  </div>
</header>

        {MAJOR_SECTIONS.map(section => (
          <section
            key={section.title}
            id={slugify(section.title)}         
            className="ae2-section"
          >
            <h2 className="ae2-heading">{section.title}</h2>
            <div className="ae2-grid">
              {section.items.map(ex => (
                <article key={ex.id} className={`ae2-card ${ex.status !== "live" ? "disabled" : ""}`}>
                  <div className="ae2-card-head">
                    <div className="ae2-icon">{ex.icon || "📘"}</div>
                    <div className="ae2-meta">
                      <h3 className="ae2-name">{ex.name}</h3>
                      <div className="ae2-badges">
                        {/* <span className="badge lvl">{ex.level}</span> */}
                        {ex.status !== "live" && <span className="badge soon">Coming soon</span>}
                      </div>
                    </div>
                  </div>

                  {ex.tags?.length ? (
                    <div className="ae2-tags">
                      {ex.tags.slice(0, 4).map(t => <span key={t} className="tag">#{t}</span>)}
                    </div>
                  ) : null}

                  <div className="ae2-stats">
                    <span>🧩 {ex.totalQuizzes} topics</span>
                    <span>📝 {ex.totalQuestions} questions</span>
                  </div>

                  <div className="ae2-cta">
                    <button
                      className="primary-btn"
                      disabled={ex.status !== "live"}
                      onClick={() => handleStart(ex.slug, ex.status)}
                      aria-disabled={ex.status !== "live"}
                    >
                      Start Practice
                    </button>
                    {/* <Link
                      className="ghost-btn"
                      to={`/practice-test-exam-prep/${ex.slug}`}
                      state={{ type: "category-test" }}
                    >
                      View All Quizzes
                    </Link> */}
                  </div>
                </article>
              ))}
            </div>
          </section>
        ))}
      </main>
    </>
  );
}